// On a pristine source environment, eslint will complain about importing files that don't exist
// because lingui hasn't created them yet (part of the build process). We need to disable these rules
// here
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */

import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { en as enPlurals } from 'make-plural/plurals';

import en from '../../locales/en/messages';

i18n.loadLocaleData('en', { plurals: enPlurals });
i18n.load('en', en.messages);
i18n.activate('en');

export default function Lingui(props) {
    const { children } = props;

    return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
